var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Instagram",
    "data-name": "Icon - Instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.478,
    height: 30.478,
    viewBox: "0 0 30.478 30.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M8.551,6.121a4.237,4.237,0,0,0-4.385,4.087A4.237,4.237,0,0,0,8.551,14.3a4.237,4.237,0,0,0,4.385-4.087A4.237,4.237,0,0,0,8.551,6.121Zm0,6.744A2.764,2.764,0,0,1,5.7,10.208,2.762,2.762,0,0,1,8.551,7.551,2.762,2.762,0,0,1,11.4,10.208a2.764,2.764,0,0,1-2.851,2.657Zm5.588-6.911a1.025,1.025,0,0,1-2.046,0,1.025,1.025,0,0,1,2.046,0Zm2.9.968a4.544,4.544,0,0,0-1.382-3.34,5.308,5.308,0,0,0-3.584-1.288c-1.412-.075-5.645-.075-7.057,0A5.3,5.3,0,0,0,1.436,3.578,4.559,4.559,0,0,0,.055,6.918c-.08,1.316-.08,5.261,0,6.577a4.544,4.544,0,0,0,1.382,3.34A5.315,5.315,0,0,0,5.02,18.123c1.412.075,5.645.075,7.057,0a5.273,5.273,0,0,0,3.584-1.288,4.574,4.574,0,0,0,1.382-3.34c.08-1.316.08-5.257,0-6.573Zm-1.824,7.986a2.8,2.8,0,0,1-1.626,1.515c-1.126.416-3.8.32-5.042.32s-3.92.092-5.042-.32a2.8,2.8,0,0,1-1.626-1.515c-.447-1.049-.343-3.539-.343-4.7s-.1-3.653.343-4.7A2.8,2.8,0,0,1,3.509,3.994c1.126-.416,3.8-.32,5.042-.32s3.92-.092,5.042.32a2.8,2.8,0,0,1,1.626,1.515c.447,1.049.343,3.539.343,4.7S15.665,13.861,15.218,14.907Z",
    transform: "translate(7.062 4.474)",
    fill: "#303030"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 15.239,
    r: 15.239,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 15.239,
    r: 14.739,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.ed32f5201bedc3f2dee089aaab9bb745.svg";
export { ForwardRef as ReactComponent };